<script setup lang="ts">
export interface CircularLoaderProps {
	duration?: number;
	foreground?: string;
	background?: string;
	stopAnimation?: boolean;
}

const props = withDefaults(defineProps<CircularLoaderProps>(), {
	duration: 5000,
	background: 'transparent',
	foreground: `var(--fallback-p,oklch(var(--p)/var(--tw-bg-opacity, 1)))`,
	stopAnimation: false,
});
const durationInSeconds = `${Math.round(props.duration / 1000)}s`;
</script>

<template>
	<div
		role="progressbar"
		aria-valuemin="0"
		aria-valuemax="100"
		class="progress-bar flex items-center justify-center rounded-full p-1"
		:class="{ 'animate-none': props.stopAnimation }"
	>
		<span
			class="flex h-full w-full items-center justify-center rounded-full bg-white"
		>
			<slot />
		</span>
	</div>
</template>

<style lang="css" scoped>
.progress-bar {
	background: conic-gradient(
		v-bind(foreground) calc(var(--progress-value) * 1%),
		v-bind(background) 0
	);
	animation: progress v-bind(durationInSeconds) 1 forwards;
}
.progress-bar.animate-none {
	background: transparent;
	animation: none;
}
</style>
